<template>
  <div id="edicaoParticipantesContrato">
    <validation-observer ref="validationobserver" v-slot="{ handleSubmit }">
      <b-form @submit.prevent="handleSubmit(salvar)" class="">
        <b-row>
          <b-col cols="6">
            <h5 class="text-left">{{ tituloPagina }}</h5>
          </b-col>
          <b-col cols="6">
            <b-button
              v-if="editParticipante"
              @click.prevent="limparForm"
              size="sm"
              variant="danger"
              class="float-right"
            >
              <font-awesome-icon icon="ban" />
              Cancelar alteração
            </b-button>
          </b-col>
        </b-row>
        <b-alert :show="participanteUg !== false" dismissible variant="warning">
          O CNPJ informado pertence à seguinte unidade gestora:
          {{ participanteUg?.NmNome }}
        </b-alert>
        <b-row>
          <b-col cols="12" sm="6" xl="2">
            <default-form-validation-provider label="País" rules="required" v-slot="defState">
              <b-form-select
                v-model="novoParticipante.TldParticipante"
                :state="defState.state"
                :options="tldPaisesOptions"
              />
            </default-form-validation-provider>
          </b-col>
          <b-col cols="12" sm="6" xl="2">
            <default-form-validation-provider
              label="CPF / CNPJ / Doc."
              :rules="novoParticipante.TldParticipante === 'BR' ? 'required|min:11|max:14|numeric' : 'required|max:12'"
              v-slot="defState"
            >
              <b-form-input
                v-model="novoParticipante.CdCpfCnpjParticipante"
                :state="defState.state"
                @blur="novoParticipante.TldParticipante === 'BR' ? checarParticipanteUg() : null"
              />
            </default-form-validation-provider>
          </b-col>
          <b-col cols="12" sm="6" xl="2">
            <default-form-validation-provider
              label="Nome / Razão Social"
              rules="required|max:120"
              v-slot="defState"
            >
              <b-form-input
                v-model="novoParticipante.NmParticipante"
                :state="defState.state"
              ></b-form-input>
            </default-form-validation-provider>
          </b-col>
          <b-col cols="12" sm="6" xl="2">
            <default-form-validation-provider label="Valor" v-slot="defState">
              <money
                class="form-control"
                v-model="novoParticipante.VlParticipacao"
                v-bind="vMoneyOptions"
                :state="defState.state"
              />
            </default-form-validation-provider>
          </b-col>
          <b-col v-if="habilitarConsorcio === true" cols="12" sm="6" xl="2">
            <default-form-validation-provider label="Consórcio?" v-slot="defState">
              <b-form-radio-group
                :state="defState.state"
                v-model="novoParticipante.FlConsorcio"
                :options="[
                  { text: 'Sim', value: 'S' },
                  { text: 'Não', value: 'N' },
                ]"
                size="sm"
              >
              </b-form-radio-group>
            </default-form-validation-provider>
          </b-col>
          <b-col
            cols="12"
            md="3"
            class="d-flex flex-column justify-content-center"
          >
            <b-button block type="submit" class="mb-2">
              <font-awesome-icon :icon="editParticipante ? 'edit' : 'plus'" />
              {{ editParticipante ? "Alterar" : "Adicionar" }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
    <b-row>
      <h5 class="text-left ml-3">{{ tituloTabela }}</h5>
      <b-table
        :fields="fields"
        :items="participantes"
        :busy="tableBusy"
        :current-page="currentPage"
        hover
        no-border-collapse
        sort-by=""
        :sort-desc="true"
        stacked="sm"
        responsive
        show-empty
      >
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <div class="actions-icons">
            <b-link
              class="text-dark"
              @click="editarParticipanteContrato(row.item)"
            >
              <font-awesome-icon icon="edit" />
              <div style="font-size: 12px">Editar</div>
            </b-link>
            <btn-excluir :idItem="row.item" :excluirItem="confirmarRemocao" />
          </div>
        </template>
      </b-table>
      <table-pagination
        v-if="totalRows > pageSize"
        :total-rows="totalRows"
        :per-page="pageSize"
        @pageChange="pageChange"
      />
    </b-row>
  </div>
</template>

<script lang="ts">
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import BtnExcluir from "@/components/shared/btn-excluir.vue";
import { eventBus } from "@/main";
import contratoService from "@/services/licitacoes/contratoService";
import { store } from "@/store";
import {
  fieldEdicaoParticipanteContrato,
  fieldsParticipanteContrato,
} from "@/types/licitacoes/contratos/fields-participante-contrato";
import { ParticipanteContrato } from "@/types/licitacoes/contratos/participante-contrato";
import { Money } from "v-money";
import { TableField } from "@/types/table-field";
import { UtilsTS } from "@/utilsts";
import { ValidationObserver } from "vee-validate";
import { mixins } from "vue-class-component";
import { Component, Ref, Vue } from "vue-property-decorator";

const CompProps = Vue.extend({
  name: "AbaEditarParticipantesContrato",
  components: {
    BtnExcluir,
    DefaultFormValidationProvider,
    TablePagination,
    ValidationObserver,
    Money,
  },
  props: {
    ctr: {
      type: Object,
      required: true,
    },
  },
});

@Component
export default class AbaEditarParticipantesContrato extends mixins(
  UtilsTS,
  CompProps
) {
  @Ref("validationobserver") validationobserver: InstanceType<
    typeof ValidationObserver
  >;
  novoParticipante: ParticipanteContrato = new ParticipanteContrato();
  editParticipante = false; //true para modo edição, false para modo inclusão
  participanteUg: any = false;
  habilitarConsorcio: any = false;
  tldPaisesOptions: { value: string; text: string }[] = [];

  //table-related
  fields: TableField[] = [
    ...fieldsParticipanteContrato,
    fieldEdicaoParticipanteContrato,
  ];
  participantes: ParticipanteContrato[] = [];
  currentPage = 1;
  pageSize = 10;
  totalRows = 0;
  tableBusy = false;

  get tituloPagina() {
    return `${this.editParticipante ? "Atualizar" : "Adicionar"} ${
      this.termoSingular
    }`;
  }
  get tituloTabela() {
    return `Contratados`;
  }
  get termoSingular() {
    return "contratado";
  }
  get termoPlural() {
    return "contratados";
  }
  get nomeTipo() {
    return "contrato/ordem de fornecimento";
  }

  /** Validar e adicionar/alterar um participante a um contrato existente */
  async salvar(): Promise<void> {
    try {
      store.blockScreen = true;
      const isValid = await this.validationobserver.validate();
      if (!isValid) {
        console.error(this.validationobserver);
      } else {
        //salvar
        const retorno = await contratoService.adicionarParticipanteContrato(
          this.novoParticipante
        );
        if (this.editParticipante) {
          this.$toast.success(
            `O ${this.termoSingular} ${retorno.NmParticipante} foi atualizado.`
          );
          this.participantes = this.participantes.filter(
            (p) => p.IdParticipanteContrato !== retorno.IdParticipanteContrato
          );
        } else {
          this.$toast.success(
            `O ${this.termoSingular} ${retorno.NmParticipante} foi adicionado a este ${this.nomeTipo}.`
          );
          this.totalRows++;
        }
        this.participantes.unshift(retorno);
        eventBus.$emit("atualizar-status-contrato");
        this.limparForm();
      }
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }

  async limparForm() {
    this.novoParticipante = new ParticipanteContrato();
    this.novoParticipante.IdContrato = this.ctr.IdContrato;
    this.editParticipante = false;
    this.validationobserver.reset();
  }

  async mounted() {
    this.novoParticipante.IdContrato = this.ctr.IdContrato;
    const response = await contratoService.habilitarConsorcio(this.ctr.IdContrato)
    this.habilitarConsorcio = response;
    this.carregarTldPaises();
    this.loadData();
  }

  async carregarTldPaises() {
    const lista = await contratoService.getListaTldPaises();
    this.tldPaisesOptions = lista.map(p => ({ value: p.Sigla, text: `${p.Sigla} - ${p.Descricao}` }));
  }
  async loadData() {
    try {
      this.participanteUg = false;
      this.tableBusy = true;
      const response = await contratoService.buscarParticipantes(
        this.ctr.IdContrato,
        this.currentPage,
        this.pageSize
      );
      if (response) {
        this.participantes = response.participantes.map((p) => {
          const participante = Object.assign(new ParticipanteContrato(), p);
          return participante;
        });
        this.totalRows = response.totalRows;
      } else {
        this.$toast.error(`Erro ao consultar os ${this.termoPlural}.`);
      }
    } finally {
      this.tableBusy = false;
    }
  }

  async pageChange(value) {
    this.currentPage = value;
    await this.loadData();
  }

  async editarParticipanteContrato(value: ParticipanteContrato) {
    this.novoParticipante = Object.assign(new ParticipanteContrato(), value);
    this.novoParticipante.IdContrato = this.ctr.IdContrato;
    this.editParticipante = true;
  }
  async confirmarRemocao(item: ParticipanteContrato) {
    try {
      await this.removerParticipanteContrato(item);
    } catch (e: any) {
      this.tratarError(e);
    }
  }
  async removerParticipanteContrato(item: ParticipanteContrato) {
    try {
      const retorno = await contratoService.removerParticipanteContrato(
        item.IdParticipanteContrato
      );
      if (retorno) {
        this.participantes = this.participantes.filter(
          (p) => p.IdParticipanteContrato !== item.IdParticipanteContrato
        );
        this.$emit("input", this.participantes);
        eventBus.$emit("atualizar-status-contrato");
        this.$toast.success(
          `O ${this.termoSingular} ${item.NmParticipante} foi removido deste ${this.nomeTipo}.`
        );
      } else
        this.$toast.error(
          `Falha ao remover o ${this.termoSingular} ${item.NmParticipante}.`
        );
      //console.log("editarParticipantesContrato.removerParticipanteContrato recebeu",retorno);
    } catch (e: any) {
      this.tratarError(e);
    }
  }

  async checarParticipanteUg(): Promise<void> {
    try {
      const retorno = await contratoService.checarParticipanteUg(
        this.novoParticipante.CdCpfCnpjParticipante
      );
      this.participanteUg = retorno.data;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>

<style scoped>
div.h7rem {
  height: 7rem;
}

@media screen and (max-width: 768px) {
  div.h7rem {
    height: 10rem;
  }
}
</style>